import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#05070f]">
        <Loader2 className="h-6 w-6 animate-spin text-cyber-cyan" />
      </div>
    );
  if (!user) return <Navigate to="/acceso" replace />;
  return children;
};
